import styled, { css } from "styled-components";
import { Colors, FInter, FlexBox, Fonts } from '@brg/ui'
import { LayoutConst } from "core";

export const ModalText = styled(FInter.Text)<{ color?: string }>`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 17px;
  line-height: 22px;
  text-align: center;
  letter-spacing: -0.34px;
  color: ${({ color }) => color || Colors.galBlack100};
`;


export const TagsSearchInputWrapper = styled(FlexBox)<{ isWhite?: boolean }>`
  place-items: baseline;
  svg {
    display: block;
  }

  padding: 0 16px;
  border: 1px solid transparent;
  place-items: center;

  ${({isWhite}) => isWhite ? css`
    background-color: rgb(242, 242, 242);
  ` : css`
    background-color: rgb(63, 69, 72);
  `}

  border-radius: 3px;

  &:focus, &:active, &:hover {
    border: 1px solid ${({ isWhite }) => isWhite  ? 'rgb(205, 205, 205)' : 'rgb(87, 91, 94)'} !important;
  }

  input {
    font-size: 13px;
    line-height: 18px;
    height: 44px;
    margin: 0;

    &::placeholder {
      color: ${({ theme, isWhite }) =>  isWhite ? '#151514' : theme.tags.modal.search.color}
      font-size: 13px;
      line-height: 18px;
    }
  }
`

export const TagsSearchInput = styled.input.attrs({ className: "--input" })<{ isMobileInput?: boolean, isWhite?: boolean }>`
  color: ${(p) => p.theme.tagSearch.inputColor};
  width: 100%;
  height: 44px;
  background: ${p => p?.isMobileInput ? p?.theme.tagSearch.background : 'transparent'};
  border: none;
  outline: none;
  padding: 0px 0px 0px 16px;

  font-size: 13px;
  line-height: 18px;

  ${({isWhite}) => isWhite && css`
    color: #151514;
  `}

  ::placeholder {
    color: ${(p) => p?.isWhite ? '#909090' :p.theme.tagSearch.inputColor};
    font-size: 13px;
    line-height: 18px;
  }
  @media (max-width: ${LayoutConst.screen.m}px) {
    padding: 15px 16px 13px;
    border-bottom: none;

    height: initial;
    ::placeholder {
      color: ${Colors.galBlack47};
    }
  }
`;

export const TagsSearchModalContainer = styled(FlexBox).attrs({
  className: "--container",
})<{isCenterModal?: boolean}>`
  flex-direction: column;
  overflow-y: hidden;
  width: ${LayoutConst.container.l}px;
  margin: 170px auto 0;

  @media(max-width: ${LayoutConst.screen.l_12}px) {
    max-width: ${LayoutConst.container.m}px;
    width: ${LayoutConst.container.m}px;
    min-width: ${LayoutConst.container.m}px;
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    max-width: ${LayoutConst.container.xs}px;
    width: ${LayoutConst.container.xs}px;
    min-width: ${LayoutConst.container.xs}px;
    margin: 92px auto 0;
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    width: calc(100% - 20px);
    max-width: calc(100% - 20px);
    min-width: calc(100% - 20px);
  }


  ${({isCenterModal}) => isCenterModal && css`
    @media (min-width: ${LayoutConst.screen.m}px) {
      justify-content: center;
      align-items: center;
      height: calc(100% - 204px);
    }
  `}
`;

export const NoProjectWrapper = styled(FlexBox)`
  width: 100%;
  align-items: center;
  justify-content: center;
  margin-top: 56px;

  color: ${Colors.galBlack47};
  font-size: 30px;
  line-height: 40px;
`

export const TagsSearchModalWrapper = styled.div.attrs({
  className: "tags-search-modal",
})<{scroll?: boolean, isWhite?: boolean, autoScroll?: boolean}>`
  user-select: none;
  height: 100vh;
  width: 100%;
  overflow-y: scroll;

  &::-webkit-scrollbar {
    height: 1px;
    width: 2px;
  }
  &::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.app?.backgroundColor === '#FEFEFE' ? `${Colors.geoWhite47}` : `${Colors.geoWhite100}`};
  }

  *::-webkit-scrollbar {
    width: 6px; /* ширина scrollbar */
    height: 10px;
  }
  *::-webkit-scrollbar-track {
    background: transparent; /* цвет дорожки */
  }
  *::-webkit-scrollbar-thumb {
    border-radius: 3px; /* закругления плашки */
    background: rgba(0, 0, 0, 0.596);
  }

  ${({isWhite}) => isWhite && css`
    background: ${({ theme }) => theme.cardsEmptyModal.bg};
  `}
`;

export const TagsSearchTitle = styled(FInter.SectionTitleSubtitleBoldDiv)<{ isWhite?: boolean }>`
  font-size: 43px;
  line-height: 51px;
  font-weight: 600;
  letter-spacing: -0.02em;
  color: ${({ theme }) => theme.app.text};

  ${({isWhite}) => isWhite && css`
    color: #151514;
  `}
  :first-letter {
    text-transform: capitalize;

    @media (max-width: ${LayoutConst.screen.m}px) {
      text-transform: none;
    }
  }
  @media (max-width: ${LayoutConst.screen.m}px) {
    font-size: 34px;
    line-height: 41px;
  }
`


export const ProjectTabItem = styled.div<{ isActive?: boolean }>`
  font-size: 17px;
  line-height: 22px;
  font-weight: 600;
  letter-spacing: -0.02em;
  color: ${({isActive}) => isActive ? Colors.galBlack100 : Colors.galBlack47};
  cursor: pointer;
`

export const CardsWrapper = styled.div`
  .main-page-masonry-grid {
    display: -webkit-box; /* Not needed if autoprefixing */
    display: -ms-flexbox; /* Not needed if autoprefixing */
    display: flex;
    margin-left: -24px; /* gutter size offset */
    width: auto;
  }

  .main-page-masonry-grid_column {
    padding-left: 24px; /* gutter size */
    background-clip: padding-box;
  }

  @media (max-width: ${LayoutConst.screen.l}px) {
    .main-page-masonry-grid_column {
      padding-left: 6px;
    }
    .main-page-masonry-grid {
      margin-left: -6px;
    }
  }
  @media (max-width: ${LayoutConst.screen.s}px) {
    .main-page-masonry-grid_column:nth-child(2) {
      ${p => p ? 'padding-left: 10px' : ''};
    }
  }
`;

export const RingWrapper = styled(FlexBox)`
  width: 100%;
  position: absolute;
  z-index: 1;
  justify-content: flex-end;
  right: 16px;
  top: 12px;
`;

export const NotSavedModalWrapper = styled.div`
  position: absolute;
  z-index: 999999;
  top: 0;
  left: 0;
  width: 100%;
  //height: calc(100% - 64px);
  height: 100%;
  background-color: rgba(0, 0, 0, 0.24);
`;

export const NotSavedContentWrapper = styled.div<{ pos?: string | number}>`
  position: fixed;
  z-index: 999999;
  top: ${(p) => p?.pos ? `${p?.pos}%` : '50%'};
  left: 50%;
  transform: ${(p) => p?.pos ? `translateX(-50%)` : 'translate(-50%, -50%)'};
  width: 564px;
  height: 274px;
  max-width: 564px;
  max-height: 274px;
  background-color: #FEFEFE;
  padding: 29px 52px 0 52px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.12);
  border-radius: 8px;
`;

export const ModalName = styled(FlexBox)`
  ${Fonts.Inter.text};
  font-style: normal;
  font-weight: 700;
  font-size: 22px;
  line-height: 40px;
  text-align: center;
  letter-spacing: -0.02em;
  color: #151514;
`;

export const ModalDescription = styled(FlexBox)`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 17px;
  line-height: 22px;
  text-align: center;
  letter-spacing: -0.02em;
  color: #70706F;
`;

export const ModalButton = styled.div<{ fill?: string, width?: number, disabled?: boolean }>`
  background-color: ${(p) => p?.fill ? p?.fill : 'transparent'};
  width: ${(p) => p?.width ? `${p?.width}px` : '163px' };
  height: 40px;
  border: 1px solid #B6B6B5;
  cursor: pointer;
  border-radius: 3px;
  text-align: center;
  padding: 13px 0px;
  font-family: 'Inter';
  display: flex;
  place-items: center;
  justify-content: center;
  font-style: normal;
  font-weight: 600;
  font-size: 17px;
  line-height: 22px;
  letter-spacing: -0.02em;
  color: ${(p) => p?.fill ? 'white' : '#151514'};

  ${({ disabled }) => disabled && css`
    pointer-events: none;
    color: #b6b6b5;
    background-color: #f2f2f2;
    cursor: normal;
    border: 1px solid transparent;
  `};

`;

export const ModalClose = styled(FlexBox)`
  svg {
    cursor: pointer;
  }
`;

export const CardsEmptyTitle = styled(FInter.SectionTitleSubtitleBoldDiv)`
  font-size: 43px;
  font-weight: 600;
  line-height: 51px;
  letter-spacing: -0.02em;
  color: ${({ theme }) => theme.cardsEmptyModal.titleColor};
`

export const CardsEmptySubTitle = styled(FInter.SectionTitleSubtitleBoldDiv)`
  font-size: 30px;
  font-weight: 400;
  line-height: 40px;
  letter-spacing: -0.02em;
  color: ${({ theme }) => theme.cardsEmptyModal.subtitleColor};
  margin-top: 16px;
  text-align: center;
  width: 735px;
`

export const CardsEmptyButtonWrapper = styled(FlexBox)`
  margin-top: 40px;
  column-gap: 24px;
`

export const CardsEmptyButton = styled(FlexBox)`
  width: 319px;
  height: 48px;
  cursor: pointer;
  border-radius: 3px;
  font-size: 17px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  justify-content: center;
  letter-spacing: -0.02em;
  align-items: center;
`

export const CardsEmptyButtonHollow = styled(CardsEmptyButton)`
  border: 1px solid ${({ theme }) => theme.cardsEmptyModal.buttons.hollow.border};
  color: ${({ theme }) => theme.cardsEmptyModal.buttons.hollow.color};
`

export const CardsEmptyButtonFilled = styled(CardsEmptyButton)`
  border: 1px solid ${({ theme }) => theme.cardsEmptyModal.buttons.filled.bg};
  background: ${({ theme }) => theme.cardsEmptyModal.buttons.filled.bg};
  color: ${({ theme }) => theme.cardsEmptyModal.buttons.filled.color};
`
import styled, { css } from "styled-components";
import { Colors, FInter, FlexBox, Fonts } from '@brg/ui'
import { LayoutConst } from "core";

export const ModalText = styled(FInter.Text)<{ color?: string }>`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 17px;
  line-height: 22px;
  text-align: center;
  letter-spacing: -0.34px;
  color: ${({ color }) => color || Colors.galBlack100};
`;


export const TagsSearchInputWrapper = styled(FlexBox)<{ isWhite?: boolean }>`
  place-items: baseline;
  svg {
    display: block;
  }

  padding: 0 16px;
  border: 1px solid transparent;
  place-items: center;

  ${({isWhite}) => isWhite ? css`
    background-color: rgb(242, 242, 242);
  ` : css`
    background-color: rgb(63, 69, 72);
  `}

  border-radius: 3px;

  &:focus, &:active, &:hover {
    border: 1px solid ${({ isWhite }) => isWhite  ? 'rgb(205, 205, 205)' : 'rgb(87, 91, 94)'} !important;
  }

  input {
    font-size: 13px;
    line-height: 18px;
    height: 44px;
    margin: 0;

    &::placeholder {
      color: ${({ theme, isWhite }) =>  isWhite ? '#151514' : theme.tags.modal.search.color}
      font-size: 13px;
      line-height: 18px;
    }
  }
`

export const TagsSearchInput = styled.input.attrs({ className: "--input" })<{ isMobileInput?: boolean, isWhite?: boolean }>`
  color: ${(p) => p.theme.tagSearch.inputColor};
  width: 100%;
  height: 44px;
  background: ${p => p?.isMobileInput ? p?.theme.tagSearch.background : 'transparent'};
  border: none;
  outline: none;
  padding: 0px 0px 0px 16px;

  font-size: 13px;
  line-height: 18px;

  ${({isWhite}) => isWhite && css`
    color: #151514;
  `}

  ::placeholder {
    color: ${(p) => p?.isWhite ? '#909090' :p.theme.tagSearch.inputColor};
    font-size: 13px;
    line-height: 18px;
  }
  @media (max-width: ${LayoutConst.screen.m}px) {
    padding: 15px 16px 13px;
    border-bottom: none;

    height: initial;
    ::placeholder {
      color: ${Colors.galBlack47};
    }
  }
`;

export const TagsSearchModalContainer = styled(FlexBox).attrs({
  className: "--container",
})<{isCenterModal?: boolean}>`
  flex-direction: column;
  overflow-y: hidden;
  width: ${LayoutConst.container.l}px;
  margin: 170px auto 0;

  @media(max-width: ${LayoutConst.screen.l_12}px) {
    max-width: ${LayoutConst.container.m}px;
    width: ${LayoutConst.container.m}px;
    min-width: ${LayoutConst.container.m}px;
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    max-width: ${LayoutConst.container.xs}px;
    width: ${LayoutConst.container.xs}px;
    min-width: ${LayoutConst.container.xs}px;
    margin: 92px auto 0;
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    width: calc(100% - 20px);
    max-width: calc(100% - 20px);
    min-width: calc(100% - 20px);
  }


  ${({isCenterModal}) => isCenterModal && css`
    @media (min-width: ${LayoutConst.screen.m}px) {
      justify-content: center;
      align-items: center;
      height: calc(100% - 204px);
    }
  `}
`;

export const NoProjectWrapper = styled(FlexBox)`
  width: 100%;
  align-items: center;
  justify-content: center;
  margin-top: 56px;

  color: ${Colors.galBlack47};
  font-size: 30px;
  line-height: 40px;
`

export const TagsSearchModalWrapper = styled.div.attrs({
  className: "tags-search-modal",
})<{scroll?: boolean, isWhite?: boolean, autoScroll?: boolean}>`
  user-select: none;
  height: 100vh;
  width: 100%;
  overflow-y: scroll;

  &::-webkit-scrollbar {
    height: 1px;
    width: 2px;
  }
  &::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.app?.backgroundColor === '#FEFEFE' ? `${Colors.geoWhite47}` : `${Colors.geoWhite100}`};
  }

  *::-webkit-scrollbar {
    width: 6px; /* ширина scrollbar */
    height: 10px;
  }
  *::-webkit-scrollbar-track {
    background: transparent; /* цвет дорожки */
  }
  *::-webkit-scrollbar-thumb {
    border-radius: 3px; /* закругления плашки */
    background: rgba(0, 0, 0, 0.596);
  }

  ${({isWhite}) => isWhite && css`
    background: ${({ theme }) => theme.cardsEmptyModal.bg};
  `}
`;

export const TagsSearchTitle = styled(FInter.SectionTitleSubtitleBoldDiv)<{ isWhite?: boolean }>`
  font-size: 43px;
  line-height: 51px;
  font-weight: 600;
  letter-spacing: -0.02em;
  color: ${({ theme }) => theme.app.text};

  ${({isWhite}) => isWhite && css`
    color: #151514;
  `}
  :first-letter {
    text-transform: capitalize;

    @media (max-width: ${LayoutConst.screen.m}px) {
      text-transform: none;
    }
  }
  @media (max-width: ${LayoutConst.screen.m}px) {
    font-size: 34px;
    line-height: 41px;
  }
`


export const ProjectTabItem = styled.div<{ isActive?: boolean }>`
  font-size: 17px;
  line-height: 22px;
  font-weight: 600;
  letter-spacing: -0.02em;
  color: ${({isActive}) => isActive ? Colors.galBlack100 : Colors.galBlack47};
  cursor: pointer;
`

export const CardsWrapper = styled.div`
  .main-page-masonry-grid {
    display: -webkit-box; /* Not needed if autoprefixing */
    display: -ms-flexbox; /* Not needed if autoprefixing */
    display: flex;
    margin-left: -24px; /* gutter size offset */
    width: auto;
  }

  .main-page-masonry-grid_column {
    padding-left: 24px; /* gutter size */
    background-clip: padding-box;
  }

  @media (max-width: ${LayoutConst.screen.l}px) {
    .main-page-masonry-grid_column {
      padding-left: 6px;
    }
    .main-page-masonry-grid {
      margin-left: -6px;
    }
  }
  @media (max-width: ${LayoutConst.screen.s}px) {
    .main-page-masonry-grid_column:nth-child(2) {
      ${p => p ? 'padding-left: 10px' : ''};
    }
  }
`;

export const RingWrapper = styled(FlexBox)`
  width: 100%;
  position: absolute;
  z-index: 1;
  justify-content: flex-end;
  right: 16px;
  top: 12px;
`;

export const NotSavedModalWrapper = styled.div`
  position: absolute;
  z-index: 999999;
  top: 0;
  left: 0;
  width: 100%;
  //height: calc(100% - 64px);
  height: 100%;
  background-color: rgba(0, 0, 0, 0.24);
`;

export const NotSavedContentWrapper = styled.div<{ pos?: string | number}>`
  position: fixed;
  z-index: 999999;
  top: ${(p) => p?.pos ? `${p?.pos}%` : '50%'};
  left: 50%;
  transform: ${(p) => p?.pos ? `translateX(-50%)` : 'translate(-50%, -50%)'};
  width: 564px;
  height: 274px;
  max-width: 564px;
  max-height: 274px;
  background-color: #FEFEFE;
  padding: 29px 52px 0 52px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.12);
  border-radius: 8px;
`;

export const ModalName = styled(FlexBox)`
  ${Fonts.Inter.text};
  font-style: normal;
  font-weight: 700;
  font-size: 22px;
  line-height: 40px;
  text-align: center;
  letter-spacing: -0.02em;
  color: #151514;
`;

export const ModalDescription = styled(FlexBox)`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 17px;
  line-height: 22px;
  text-align: center;
  letter-spacing: -0.02em;
  color: #70706F;
`;

export const ModalButton = styled.div<{ fill?: string, width?: number, disabled?: boolean }>`
  background-color: ${(p) => p?.fill ? p?.fill : 'transparent'};
  width: ${(p) => p?.width ? `${p?.width}px` : '163px' };
  height: 40px;
  border: 1px solid #B6B6B5;
  cursor: pointer;
  border-radius: 3px;
  text-align: center;
  padding: 13px 0px;
  font-family: 'Inter';
  display: flex;
  place-items: center;
  justify-content: center;
  font-style: normal;
  font-weight: 600;
  font-size: 17px;
  line-height: 22px;
  letter-spacing: -0.02em;
  color: ${(p) => p?.fill ? 'white' : '#151514'};

  ${({ disabled }) => disabled && css`
    pointer-events: none;
    color: #b6b6b5;
    background-color: #f2f2f2;
    cursor: normal;
    border: 1px solid transparent;
  `};

`;

export const ModalClose = styled(FlexBox)`
  svg {
    cursor: pointer;
  }
`;

export const CardsEmptyTitle = styled(FInter.SectionTitleSubtitleBoldDiv)`
  font-size: 43px;
  font-weight: 600;
  line-height: 51px;
  letter-spacing: -0.02em;
  color: ${({ theme }) => theme.cardsEmptyModal.titleColor};
`

export const CardsEmptySubTitle = styled(FInter.SectionTitleSubtitleBoldDiv)`
  font-size: 30px;
  font-weight: 400;
  line-height: 40px;
  letter-spacing: -0.02em;
  color: ${({ theme }) => theme.cardsEmptyModal.subtitleColor};
  margin-top: 16px;
  text-align: center;
  width: 735px;
`

export const CardsEmptyButtonWrapper = styled(FlexBox)`
  margin-top: 40px;
  column-gap: 24px;
`

export const CardsEmptyButton = styled(FlexBox)`
  width: 319px;
  height: 48px;
  cursor: pointer;
  border-radius: 3px;
  font-size: 17px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  justify-content: center;
  letter-spacing: -0.02em;
  align-items: center;
`

export const CardsEmptyButtonHollow = styled(CardsEmptyButton)`
  border: 1px solid ${({ theme }) => theme.cardsEmptyModal.buttons.hollow.border};
  color: ${({ theme }) => theme.cardsEmptyModal.buttons.hollow.color};
`

export const CardsEmptyButtonFilled = styled(CardsEmptyButton)`
  border: 1px solid ${({ theme }) => theme.cardsEmptyModal.buttons.filled.bg};
  background: ${({ theme }) => theme.cardsEmptyModal.buttons.filled.bg};
  color: ${({ theme }) => theme.cardsEmptyModal.buttons.filled.color};
`
